import React from 'react';
import classNames from 'classnames';

import Session from 'store/session';
import useApi from 'api';

import AccountDialog from './AccountDialog';

import './Account.scss';
import { OverlayContext } from 'ui/utils/OverlayManager';

const LoginLine = React.memo(function LoginLine({ className, suffix }) {
  const loggedIn = Session.useSelector(store => !!store.userName);
  const overlays = React.useContext(OverlayContext);

  const onSignIn = React.useCallback(() => overlays.async(<AccountDialog action="signin"/>), [overlays]);
  const onRegister = React.useCallback(() => overlays.async(<AccountDialog action="register"/>), [overlays]);

  if (loggedIn) return null;

  return (
    <div className={classNames("lap-LoginLine", className)}>
      <span onClick={onSignIn}>{`Sign in`}</span>{` or `}<span onClick={onRegister}>{`Register`}</span>{suffix || ""}
    </div>
  );
});

export function LoggedInLine() {
  const overlays = React.useContext(OverlayContext);
  const userName = Session.useSelector(store => store.userName);
  const api = useApi();

  const onSignOut = React.useCallback(() => api.account("signout"), [api]);
  const onSettings = React.useCallback(() => overlays.async(<AccountDialog action="options"/>), [overlays]);

  return (
    <div className="lap-LoginLine">
      {`Welcome, ${userName}`} (<span onClick={onSignOut}>{`sign out`}</span>, <span onClick={onSettings}>{`settings`}</span>)
    </div>
  );
}

export const LoginBar = React.memo(function LoginBar() {
  const overlays = React.useContext(OverlayContext);

  React.useEffect(() => {
    if (document.location.search) {
      const url = new URL(document.location.href);
      const reset = url.searchParams && url.searchParams.get("reset");
      if (reset) {
        url.search = "";
        overlays.async(<AccountDialog action="reset" params={{reset_code: reset}}/>);
        window.history.replaceState({}, "", url.href);        
      }
    }
  }, [overlays]);

  const loggedIn = Session.useSelector(store => !!store.userName);
  return (
    <div className="lap-LoginBar">
      {loggedIn ? <LoggedInLine/> : <LoginLine/>}
    </div>
  );
});

export default LoginLine;
